import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { primaryBlue, textColorGray } from 'theme/mainColors';

class MaterialNumberField extends React.PureComponent {
  state = {
    touched: false
  };

  handleTextFieldChange = (event, value) => {
    let onlyNums = '';
    this.props.allowNegative
      ? (onlyNums = value.replace(/[^-?0-9.]/g, ''))
      : (onlyNums = value.replace(/[^0-9.]/g, ''));
    const percentageValue = onlyNums.substring(0, 3);
    this.props.isPercentageValue
      ? (onlyNums =
          parseInt(percentageValue) > 100
            ? onlyNums / 100 > 1
              ? percentageValue.substring(0, 2)
              : 100
            : percentageValue)
      : percentageValue;
    this.props.onChange(event, onlyNums);
  };

  handleOnBlur = ev => {
    this.setState({ touched: true });
    this.props.onBlur(ev);
  };

  render() {
    const {
      name,
      label,
      value,
      hintText,
      fullWidth,
      style,
      required,
      pristineForm,
      errorText,
      disabled
    } = this.props;
    return (
      <TextField
        fullWidth={ fullWidth }
        floatingLabelText={ label }
        value={ value }
        name={ name }
        onChange={ this.handleTextFieldChange }
        onBlur={ this.handleOnBlur }
        floatingLabelStyle={ { color: textColorGray } }
        underlineStyle={ { borderColor: textColorGray } }
        underlineFocusStyle={ { borderColor: primaryBlue } }
        inputStyle={ { fontSize: 15 } }
        style={ style }
        errorText={
          errorText ||
          (required && !value && this.state.touched && !pristineForm
            ? 'This field is required'
            : '')
        }
        hintText={ hintText }
        disabled={ disabled }
      />
    );
  }
}

MaterialNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  allowNegative: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  required: PropTypes.bool,
  pristineForm: PropTypes.bool,
  hintText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  onBlur: PropTypes.func,
  style: PropTypes.object,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  isPercentageValue: PropTypes.bool
};

MaterialNumberField.defaultProps = {
  hintText: '',
  required: false,
  fullWidth: true,
  pristineForm: false,
  style: {},
  onBlur: () => null,
  errorText: '',
  disabled: false,
  isPercentageValue: false,
  allowNegative: false
};

export default MaterialNumberField;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/c/materialNumberField/MaterialNumberField.js